import type { SVGProps } from 'react';
const SvgShoppingCart = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Shopping Cart 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M14.464 17.84a.66.66 0 1 1 0-1.322.66.66 0 0 1 0 1.321M5.875 17.84a.66.66 0 1 1 0-1.322.66.66 0 0 1 0 1.321M.66.66h3.312l.349 3.304m0 0 .85 8.067c.072.673.64 1.183 1.318 1.183h8.37c.607 0 1.137-.412 1.284-1L17.8 5.605a1.322 1.322 0 0 0-1.285-1.642z" />
    </g>
  </svg>
);
export default SvgShoppingCart;
